/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Taken from theme.dev.js
  window.theme = window.theme || {};

  window.theme.sizes = {
    mobile: 480,
    small: 750,
    large: 990,
    widescreen: 1400,
  };

  function getWindowWidth() {
    return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
  }

  function getWindowHeight() {
    return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
  }

  function isDesktop() {
    return getWindowWidth() >= window.theme.sizes.small;
  }

  function isMobile() {
    return getWindowWidth() < window.theme.sizes.small;
  }

  // Add custom code below this line

  // Custom Timeline
  // TODO: Handle screen resizing
  
  var updateNavButtonState = function(btn, targetIndex) {
    if (parseInt(btn.dataset.index) <= targetIndex) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  }

  // Desktop click event on timeline nav button (including prev/next buttons)
  var handleDesktopTimelineNavEvent = function(event) {
    var nav = event.target.closest('.timeline-nav');
    if (nav) {
      var container = nav.parentNode.querySelector('.timeline-container');
      if (container) {
        // Get index for timeline item to navigate to
        var targetIndex = parseInt(event.target.dataset.index);

        // Update timline nav
        nav.querySelectorAll('button.timeline-nav__btn').forEach(function(btn) {
          updateNavButtonState(btn, targetIndex);
        });

        // "Navigate" to timeline item through hiding all inactive items
        var timelineItems = container.querySelectorAll('.timeline-item');
        timelineItems.forEach(function(item) {
          if (parseInt(item.dataset.index) === targetIndex) {
            item.style = 'opacity: 1; transform: translateX(0);';
            // setTimeout in case `item.offsetHeight` hasn't been properly set/updated
            setTimeout(() => container.style = 'height: ' + item.offsetHeight + 'px;', 200);
          } else {
            item.style = 'opacity: 0; transform: translateX(100%);';
          }
        });

        // Update target indexes for prev/next buttons 
        var prevButton = nav.querySelector('.slider__button--prev');
        if (targetIndex === 1) {
          prevButton.setAttribute('disabled', '');
          prevButton.dataset.index = 0;
        } else {
          prevButton.removeAttribute('disabled');
          prevButton.dataset.index = targetIndex - 1;
        }
        var nextButton = nav.querySelector('.slider__button--next');
        if (targetIndex === timelineItems.length) {
          nextButton.setAttribute('disabled', '');
          nextButton.dataset.index = 0;
        } else {
          nextButton.removeAttribute('disabled');
          nextButton.dataset.index = targetIndex + 1;
        }
      } else {
        console.warn('Unable to find timeline-container');
      }
    } else {
      console.warn('Unable to find timeline-nav');
    }
  }

  // Mobile tap event on timeline nav button
  var handleMobileTimelineNavEvent = function(event) {
    var targetIndex = parseInt(event.target.dataset.index);

    var item = event.target.closest('.timeline-item');
    if (!item) {
      console.warn('Unable to find timeline-item');
      return;
    }

    var container = item.closest('.timeline-container');
    if (!container) {
      console.warn('Unable to find timeline-container');
    }

    container.querySelectorAll('.timeline-item').forEach(function(item) {
      var nav = item.querySelector('.timeline-nav-mobile');
      if (nav) {
        var btn = nav.querySelector('button.timeline-nav__btn');
        if (btn) {
          updateNavButtonState(btn, targetIndex);
        }
      }
    });
    container.scroll({ left: item.offsetLeft, behavior: 'smooth' });
  }

  // Mobile scroll event on timeline items container
  var mobileTimelineScrollEvent = function(container, scrollX) {
    container.querySelectorAll('.timeline-item').forEach(function(item) {
      var nav = item.querySelector('.timeline-nav-mobile');
      if (!nav) {
        console.warn('Unable to find timeline-nav-mobile');
        return;
      }

      var btn = nav.querySelector('button.timeline-nav__btn');
      if (!btn) {
        console.warn('Unable to find timeline=-nav__btn');
        return;
      }

      // An item is considered "active" when it is half-shown on the screen
      var offset = parseInt(item.dataset.offset) - (item.offsetWidth / 2);
      if (scrollX >= offset) {
        var nextItem = item.nextSibling;
        if (!nextItem || scrollX <= parseInt(nextItem.dataset.offset) - (nextItem.offsetWidth / 2)) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
        btn.classList.add('active');
      } else {
        var prevItem = item.previousSibling;
        if (!prevItem || scrollX >= parseInt(prevItem.dataset.offset) + (prevItem.offsetWidth / 2)) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
        btn.classList.remove('active');
      }
    });
  }

  // Variables to reduce firing rate of scroll event
  var mobileTimelineLastScrollX = 0;
  var mobileTimelineTicking = false;

  // Initialization
  document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('[id^="timeline-"]').forEach(function(timeline) {
      if (isDesktop()) {
        timeline.querySelectorAll('.timeline-nav button.timeline-nav__btn, .timeline-nav .slider__arrows .slider__button').forEach(function(btn) {
          btn.addEventListener('click', handleDesktopTimelineNavEvent);
        });
        timeline.querySelector('button.timeline-nav__btn').click();
      } else {
        var container = timeline.querySelector('.timeline-container');
        if (container) {
          container.querySelectorAll('.timeline-item').forEach(function(item) {
            item.dataset.offset = item.offsetLeft;
          });
  
          container.addEventListener('scroll', function(event) {
            mobileTimelineLastScrollX = container.scrollLeft;
    
            if (!mobileTimelineTicking) {
              window.requestAnimationFrame(function() {
                mobileTimelineScrollEvent(container, mobileTimelineLastScrollX);
                mobileTimelineTicking = false;
              });
          
              mobileTimelineTicking = true;
            }
          });
        } else {
          console.warn('Unable to find timeline-container');
        }
        timeline.querySelectorAll('.timeline-nav-mobile button.timeline-nav__btn').forEach(function(btn) {
          btn.addEventListener('click', handleMobileTimelineNavEvent);
        });
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();